import { useEffect, useRef } from 'react';
import { useAppContext } from '../core/context';
import { useLanguageContext } from '../core/locale/LanguageContext';
import { viewEvents } from '../core/services/mixpanelEvents';
import PaymentSuccess from '../lib/assets/payment-success.svg';
import Agent from '../lib/assets/agent.svg';
import './PaymentResultView.css';

interface PaymentResultViewProps {
  outcome: 'success' | 'cancelled';
}

function PaymentResultView({ outcome }: PaymentResultViewProps): React.ReactNode {
  const context = useAppContext();
  const languageContext = useLanguageContext();
  const viewLoadedRef = useRef(false);
  const isSuccess = outcome === 'success';

  useEffect(() => {
    if (viewLoadedRef.current) return;
    viewLoadedRef.current = true;
    context.mixpanel?.trackViewLoad(
      isSuccess ? viewEvents.LANDING_PAGE_SUCCESS_VIEWED : viewEvents.LANDING_PAGE_CANCELLED_VIEWED
    );
  }, [context, isSuccess]);

  return (
    <>
      <div className="payment-result-illustration-wrapper">
        <img
          src={isSuccess ? PaymentSuccess : Agent}
          alt=""
          aria-hidden="true"
          className="payment-result-illustration-image"
        />
      </div>
      <div className="payment-result-header">
        <h1 className="payment-result-heading">
          {languageContext.getLocalizedText(isSuccess ? 'successHeader' : 'cancelledHeader')}
        </h1>
        <p className="payment-result-description">
          {languageContext.getLocalizedText(
            isSuccess ? 'successDescription' : 'cancelledDescription'
          )}
        </p>
      </div>
    </>
  );
}

export default PaymentResultView;
